import { INotification } from "infrastructure/notification";
import { ITerm } from "ui/screens";

export interface IAssociatedMessage {
  term: ITerm;
  messageId: string;
}

export interface IDictionaryLinksState {
  isLoading: boolean;
  notifications: INotification[];
  termsPickerData: ITerm[];
  associatedTerms: ITerm[];
  toDeleteAssociatedTerm: ITerm[];
  newAssociatedTerm: ITerm[];
  messageVersion: number;
  shouldRedirect?: boolean;
}

export const getDictionaryLinksInitialState = (): IDictionaryLinksState => {
  return {
    isLoading: false,
    associatedTerms: [],
    notifications: [],
    termsPickerData: [],
    toDeleteAssociatedTerm: [],
    messageVersion: 0,
    newAssociatedTerm: []
  };
};
